// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_HabilitaUsuarioInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /usuarios/habilitaUsuario
 *
 * Enables a user account by their Cognito username.
 */
import { registerContract } from './validate'

export interface Usuarios_HabilitaUsuarioInput {
username: string
}

registerContract('Usuarios_HabilitaUsuarioInput', {
  username: { type: 'string',  required: true },
})
